import React from "react";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { AlertTriangle, BookOpen, Brain, ShieldAlert, FileSearch, Mailbox } from "lucide-react";

const PURPOSES = [
  { icon: AlertTriangle, title: "Threat Alerts", desc: "Curated, India-first early warnings on active scams and breach patterns." },
  { icon: BookOpen, title: "Scam Research", desc: "Deep dives into UPI, OTP, KYC, investment and impersonation scams." },
  { icon: Brain, title: "AI Security Insights", desc: "What's working — and what's not — in AI-assisted defense." },
  { icon: FileSearch, title: "Fraud Intelligence", desc: "Pattern analysis from frontline reports across our awareness network." },
  { icon: ShieldAlert, title: "Awareness Reports", desc: "Quarterly trend reports tailored for CISOs, boards and educators." },
];

export default function Labs() {
  return (
    <div data-testid="labs-page">
      <PageHero
        eyebrow="Cosmos Defence Labs"
        title="Threat research, scam intelligence and AI security insights"
        description="labs.defence.cngtpl.com — our research arm delivering early warnings, scam autopsies and the AI playbooks shaping tomorrow's defenses."
        accent="purple"
      />

      <section className="py-20 bg-white">
        <div className="container-cd">
          <SectionHeading eyebrow="What we do" title="Inside the Lab" />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {PURPOSES.map((p, i) => (
              <div key={p.title} className="card-cd" data-testid={`labs-purpose-${i}`}>
                <span className="h-12 w-12 grid place-items-center rounded-xl gradient-cta text-white">
                  <p.icon size={22} strokeWidth={1.7} />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-[#0A1B5E]">{p.title}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 card-cd ring-glow-cyan border-cyan-200 flex flex-col md:flex-row items-start md:items-center gap-6 justify-between">
            <div className="flex items-start gap-4">
              <Mailbox size={28} className="text-[#22D3EE] mt-1" />
              <div>
                <div className="font-display font-bold text-xl text-[#0A1B5E]">Subscribe to Threat Alerts</div>
                <div className="text-slate-600 mt-1 text-sm">Get the freshest scam research and security advisories in your inbox.</div>
              </div>
            </div>
            <a href="mailto:secure@defence.cngtpl.com?subject=Subscribe%20to%20Threat%20Alerts" className="btn-accent" data-testid="labs-subscribe-cta">
              Subscribe
            </a>
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
